import React from 'react';
import style from './style.menu_divider';

const MenuDivider = () => (
  <hr data-react-toolbox='menu-divider' className={style.root}/>
);

export default MenuDivider;
